<script setup lang="ts">
const props = withDefaults(defineProps<{
    isActive?: boolean
    label?: string
    count?: number
    disabled?: boolean
}>(), {
    isActive: false,
    label: 'All',
    count: 0,
    disabled: false,
})

const emit = defineEmits<{
    'click': [value: boolean]
    'keydown': [keyEvent: KeyboardEvent]
}>()

const emitClick = () => {
    emit('click', true)
    return true
}

const emitKeydown = (keyEvent: KeyboardEvent) => {
    emit('keydown', keyEvent)
    return keyEvent
}
</script>

<template>
    <div
        class="content-tab"
        :class="{
            'content-tab--active': props.isActive,
            'content-tab--disabled': props.disabled
        }"
        tabindex="0"
        :aria-label="`${props.count} ${props.label} questions`"
        @keydown.enter="emitKeydown"
        @click="emitClick"
        @mousedown.prevent
    >
        <slot name="content">
            <div class="content-tab__label" aria-hidden="true">
                <slot name="label">
                    {{ props.label }}
                </slot>
            </div>
            <div class="content-tab__count" aria-hidden="true">
                <slot name="count">
                    {{ props.count }}
                </slot>
            </div>
        </slot>
    </div>
</template>

<style lang="scss" scoped>


.content-tab {
    width: 84px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-bottom: 4px solid $white;
    color: $slate-01;
    margin-right: 2px;
    cursor: pointer;
    user-select: none;
    flex-direction: column;
    outline: none;
    font-weight: 600;

    &:not(&--disabled) {
        &:hover {
            color: $brand-blue;
        }
    }

    &:focus::before {
        content: '';
        position: absolute;
        left: 0;
        top: -7px;
        width: 83px;
        height: 56px;
        border: 1px solid $brand-blue;
        border-radius: 6px;
        box-sizing: border-box;
    }

    &--active {
        border-bottom-color: $brand-black;
        color: $brand-black !important;
    }

    &__label {
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.39px;
        margin-bottom: 2px;
    }

    &__count {
        font-size: 25px;
        line-height: 30px;
        letter-spacing: -0.5px;
        padding-bottom: 5px;
    }

    &--disabled {
        cursor: default;
    }
}
</style>
